"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentData = void 0;
const react_1 = __importStar(require("react"));
const commons_v2_input_1 = require("@experta/commons-v2.input");
const commons_v2_select_1 = require("@experta/commons-v2.select");
require("./payment-data.css");
const lang = __importStar(require("./lang.json"));
;
/**
 * Main component.
 * @name PaymentData
 * @param {PaymentDataProps<T>}
 * @returns {<PaymentData />}
*/
exports.PaymentData = (0, react_1.forwardRef)(({ formData, handleChange, paymentMethods, cardCompannies, validateMethod }, ref) => {
    const selectedBank = [{ name: formData === null || formData === void 0 ? void 0 : formData.bankName, value: formData === null || formData === void 0 ? void 0 : formData.bankId }];
    const [formDataErrors, setFormDataErrors] = (0, react_1.useState)([]);
    const [localFormData, setLocalFormData] = (0, react_1.useState)(Object.assign(Object.assign({}, formData), { paymentMethod: paymentMethods[0].value }));
    (0, react_1.useEffect)(() => {
        if (formData) {
            setLocalFormData(Object.assign({}, formData));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        setLocalFormData(Object.assign(Object.assign({}, localFormData), { paymentMethod: paymentMethods[0].value }));
    }, [paymentMethods]);
    (0, react_1.useEffect)(() => {
        handleChange(localFormData);
    }, [localFormData]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        validateForm: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            let result = yield validateMethod(localFormData, lang);
            setFormDataErrors([...result.errorsMessages]);
            return ((_a = result.errorsMessages) === null || _a === void 0 ? void 0 : _a.length) === 0;
        }),
    }), [localFormData]);
    const handlerForm = (element) => {
        const key = element.target.name, value = element.target.value, newState = Object.assign(Object.assign({}, localFormData), { [key]: value });
        if (element.target.name === "paymentMethod") {
            setLocalFormData(Object.assign(Object.assign({}, localFormData), { paymentMethod: element.target.value, cardNumber: '', expirationMonth: '', expirationYear: '', cardName: '', cardCompany: '', bankId: '', bankName: '', CBU: '' }));
            setFormDataErrors([]);
        }
        else {
            setLocalFormData(newState);
        }
    };
    const hasError = (name) => {
        return formDataErrors.filter(el => el.field === name).length > 0;
    };
    const getError = (name) => {
        if (hasError(name)) {
            return formDataErrors.filter(el => el.field === name)[0].message;
        }
        else {
            return undefined;
        }
    };
    return (react_1.default.createElement("div", { className: "paymentdata-container", "data-testid": "paymentdata-element" },
        react_1.default.createElement("div", { className: "payment-form-title" },
            react_1.default.createElement("span", null, lang.title)),
        react_1.default.createElement("div", { className: "payment-method-container" }, paymentMethods.map(paymentMethod => (react_1.default.createElement("div", { className: "payment-method", key: paymentMethod.value },
            react_1.default.createElement("input", { type: "radio", id: paymentMethod.value, name: "paymentMethod", onChange: handlerForm, value: paymentMethod.value, checked: localFormData.paymentMethod === paymentMethod.value }),
            react_1.default.createElement("label", { htmlFor: paymentMethod.value }, paymentMethod.label))))),
        localFormData.paymentMethod === "CREDITO" ? (react_1.default.createElement("div", { className: "payment-data-container" },
            react_1.default.createElement("div", { className: "card-number-input" },
                react_1.default.createElement(commons_v2_input_1.Input, { label: lang.labels.credit_card, value: localFormData.cardNumber, name: "cardNumber", type: "text", onChange: handlerForm, error: hasError("cardNumber"), errorMessage: getError("cardNumber") })),
            react_1.default.createElement("div", { className: "expiration-month-input" },
                react_1.default.createElement(commons_v2_input_1.Input, { label: lang.labels.expiration_month, value: localFormData.expirationMonth, name: "expirationMonth", type: "number", onChange: handlerForm, placeholder: lang.placeholders.month, error: hasError("expirationMonth"), errorMessage: getError("expirationMonth") })),
            react_1.default.createElement("div", { className: "expiration-year-input" },
                react_1.default.createElement(commons_v2_input_1.Input, { label: lang.labels.expiration_year, value: localFormData.expirationYear, name: "expirationYear", type: "number", onChange: handlerForm, placeholder: lang.placeholders.year, error: hasError("expirationYear"), errorMessage: getError("expirationYear") })),
            react_1.default.createElement("div", { className: "card-name-input" },
                react_1.default.createElement(commons_v2_input_1.Input, { label: lang.labels.full_name, value: localFormData.cardName, name: "cardName", onChange: handlerForm, error: hasError("cardName"), errorMessage: getError("cardName") })),
            react_1.default.createElement("div", { className: "card-company-input" },
                react_1.default.createElement(commons_v2_select_1.Select, { options: cardCompannies, label: lang.selects.company, value: localFormData.cardCompany, name: "cardCompany", onChange: handlerForm, error: hasError("cardCompany"), errorMessage: getError("cardCompany") })))) : (react_1.default.createElement("div", { className: "payment-data-container" },
            react_1.default.createElement("div", { className: "cbu-input" },
                react_1.default.createElement(commons_v2_input_1.Input, { label: lang.inputs.cbu, value: localFormData.CBU, name: "CBU", type: "number", onChange: handlerForm, error: hasError("CBU"), errorMessage: getError("CBU") })),
            react_1.default.createElement("div", { className: "bank-input" },
                react_1.default.createElement(commons_v2_select_1.Select, { options: selectedBank, label: lang.selects.bank, value: localFormData.bankId, name: "bank", onChange: handlerForm, error: hasError("bank"), errorMessage: getError("bank"), disabled: true }))))));
});
//# sourceMappingURL=payment-data.js.map